import { Field, RadioGroup, Checkbox } from 'Components/Core';
import { ListFieldSection } from 'Components/Layout';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import ids from 'Components/Worksheets/QestIds';

const qestIds = [ids.soilClassification.ASTM.estimated_Al];

let MeasuredSoilClassificationEstimatedAlWorksheet = () => {
  return (
    <>
      <ListFieldSection>
        <Field
          input={<RadioGroup />}
          label="Estimated Liquid Limit"
          name="EstimatedLiquidLimitHigh"
          options={[
            { label: 'High (>= 50)', value: true },
            { label: 'Low (< 50)', value: false },
          ]}
        />
        <Field input={<Checkbox />} label="Material is organic" name="OrganicMaterial" />
        <Field
          input={<RadioGroup />}
          label="Material Classification"
          name="MaterialClassification"
          options={[
            { label: 'Silt', value: 'Silt' },
            { label: 'Clay', value: 'Clay' },
          ]}
        />
      </ListFieldSection>
    </>
  );
};

MeasuredSoilClassificationEstimatedAlWorksheet = withInjectedProps(MeasuredSoilClassificationEstimatedAlWorksheet);

MeasuredSoilClassificationEstimatedAlWorksheet.qestIds = qestIds;

export default MeasuredSoilClassificationEstimatedAlWorksheet;
export { MeasuredSoilClassificationEstimatedAlWorksheet };
